import React from 'react';
import classes from './../Onboarding.module.scss';

const LowerDiv = ({children , className ,style}) => {
    return (
        <div className={classes.LowerDiv} style={style}>
            {children}
        </div>
    )
}

export default LowerDiv